var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-navbar',{staticClass:"nabarx"},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('vs-navbar-title',[_c('Logo'),_vm._v("\n      CEMACO\n    ")],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }